import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Config } from 'src/app/_config/config';
import { FormGroup, FormBuilder } from '@angular/forms';
import __ from 'underscore';
import { DataService } from '../_service/data.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import  *  as  column  from  './columnList.json';
import { HttpClient } from "@angular/common/http";

import { ExcelService } from '../_service/excel.service';
import { FilterBaseComponent } from '../_base/filter-base.component';
declare const Highcharts: any;
declare const $: any;
declare const moment: any;
@Component({
  selector: 'app-call-distribution',
  templateUrl: './call-distribution.component.html',
  styleUrls: ['./call-distribution.component.scss']
})
export class CallDistributionComponent extends FilterBaseComponent implements OnInit {

  public config:any = new Config();
  public filterForm:FormGroup;
  public start_date:any = moment().subtract('days', 30);
  public end_date:any = moment();
  public totalCallDetails: any;
  loginData: any;

  firstTimeRun: Boolean = true;
  columnName: any;
  public channelList: any = [];
  public outletTypeList: any = [];
  channelName: any = '';
  outletTypeName: any= '';
  callVolumeSelected: any;
  callVolumeSelectedList: any = [];
  callVolumeSelectedStatus: Boolean = true;
  column:any = [];
  isSelectedAll:boolean =  false;

  constructor(
  private http: HttpClient,
  private fb: FormBuilder,
  protected dataService: DataService,
  private ExcelService: ExcelService
) {
  super(dataService);

  this.filterForm = this.fb.group({
    zone: [""],
    region: [""],
    parent_group: [""],
    outlet: [""],
    start_date: [this.start_date.format("YYYY-MM-DD")],
    end_date: [this.end_date.format("YYYY-MM-DD")],
    userType: [""],
  });
}


  ngOnInit() {
    this.loginData = (this.dataService.getCookies('loginData'))? JSON.parse(this.dataService.getCookies('loginData')).acl : JSON.parse(localStorage.getItem('loginData')).acl;

    if(this.loginData.userType === 6) { // TSM/RO
      this.parentStatus = true;
      this.callVolumeSelectedList = [
        {value: 'business_unit_name', view:'DEALER'},
        {value: 'webform_id, web_form_name', view:'OUTLET'}
      ];
      this.callVolumeSelected = 'webform_id, web_form_name';
      this.getAllParent('aa');
  } else if(this.loginData.userType === 8) { // Zonal
      this.regionStatus = true;
      this.parentStatus = true;
      this.callVolumeSelectedList = [
        {value: 'region', view:'REGION'},
        {value: 'business_unit_name', view:'DEALER'},
        {value: 'webform_id, web_form_name', view:'OUTLET'}
      ];
      this.callVolumeSelected = 'region';
      this.getAllRegion('aa');
  } else if(this.loginData.userType === 1) { // Agency or HO
      this.regionStatus = true;
      this.parentStatus = true;
      this.zoneStatus = true;
      this.channelStatus = true;
      this.callVolumeSelectedList = [
        {value: 'zone', view:'ZONE'},
        {value: 'region', view:'REGION'},
        {value: 'business_unit_name', view:'DEALER'},
        {value: 'webform_id, web_form_name', view:'OUTLET'}
      ];
      this.callVolumeSelected = 'zone';

      this.getAllZone();
  } else if(this.loginData.userType === 7) { // Agency or HO
    this.regionStatus = true;
    this.parentStatus = true;
    this.zoneStatus = true;
    this.channelStatus = true;
    this.callVolumeSelectedList = [
      {value: 'zone', view:'ZONE'},
      {value: 'region', view:'REGION'},
      {value: 'business_unit_name', view:'DEALER'},
      {value: 'webform_id, web_form_name', view:'OUTLET'}
    ];
    this.callVolumeSelected = 'zone';

    this.getAllZone();
} else if(this.loginData.userType === 9){
    this.parentStatus = true;
    this.outletStatus = true;
    this.channelStatus = true;
    this.getAllChannel("''");
    this.callVolumeSelectedList = [
      {value: 'business_unit_name', view:'DEALER'},
      {value: 'webform_id, web_form_name', view:'OUTLET'}
    ];
    this.callVolumeSelected = 'business_unit_name';
}  else if(this.loginData.userType === 10) { // Zonal manager
  this.regionStatus = true;
  this.parentStatus = true;
  // this.zoneStatus = true;
  this.channelStatus = true;
  this.callVolumeSelectedList = [
    {value: 'region', view:'REGION'},
    {value: 'business_unit_name', view:'DEALER'},
    {value: 'webform_id, web_form_name', view:'OUTLET'}
  ];
  this.callVolumeSelected = 'region';
  this.getAllRegion('aa');
}  else {
      this.regionStatus = true;
      this.outletStatus = true;
      this.channelStatus = true;
      this.getAllRegion("''");
      this.callVolumeSelectedStatus = false;
  }
        
        this.filterForm.patchValue({
            "userType": this.loginData.userType
        })
   this.initializeDateRangePicker(() => {
  this.checkCallDistributionDate();
});
    this.zoneSetting();
    this.regionSetting();
    this.parentSetting();
    this.outletSetting();
    this.columnSetting();
    this.channelSetting();
    this.outletTypeSetting();
    this.checkCallDistributionDate()
    // this.getAllZone();
    // this.advanceFilter();
  }
get isFilterApplied(): boolean {
  return (
    this.selectedZone.length > 0 ||
    this.selectedRegion.length > 0 ||
    this.selectedParent.length > 0 ||
    this.selectedOutlet.length > 0 ||
    this.selectedChannel.length > 0 ||
    this.selectedOutletType.length > 0 ||
    !this.isDefaultDateRange()
  );
}

  public advanceFilter(){
    if(this.firstTimeRun) {
      this.apiReq = {
          zone:'',
          region:'',
          parent: '',
          outlet: '',
          channel:'',
          outletType: '',
          agl_flag: '',
      }
  }
    this.getTotalLeads();
    this.getCallVolumeRegionData();
    this.getRegionWiseDurationData();
    // this.zoneChartUpper('s');
    this.getDistributionByDayData();
    this.getcallDurationPercentageData();
    this.firstTimeRun = false;
}

download() {
  if (this.selectedColumn.length === 0) {
      this.dataService.showError('Please select column name.');
  } else {
      this.dataService.startLoader();

  let finalData = {
      one: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      channel: this.channelName,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
      columnList: this.selectedColumn
  }
  this.dataService.post('callDistribution/downloadCDR', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
         // console.log('download data', res['data']);
         if (res['data'].length) {
          this.ExcelService.exportAsExcelFile(res['data'], 'call_dis_report');
          } else {
              this.dataService.showError('No Data Found.')
          }      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}
}


public getTotalLeads(){
  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    channel: this.channelName,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date
}
  this.dataService.post('callDistribution/cdrCount', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          // console.log('getTotalLeads', res)
          this.totalCallDetails = res['data'];
      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}



  public regionWiseDurationChart(info) {
    Highcharts.chart('region_wise_duration', {
      chart: {
        type: 'column'
      },
      exporting: { enabled: false },
      title: {
          text: ''
      },
      subtitle: {
          text: ''
      },
      accessibility: {
        announceNewData: {
          enabled: true
        }
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        title: {
          text: ''
        }
    
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.y}%'
          }
        }
      },
    
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}%</b> of total<br/>'
      },
    
      series:
      [
        {
          name: "",
          colorByPoint: true,
          data:info
        }
      ]
    });
}

getRegionWiseDurationData() {
  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    channel: this.channelName,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date
}
    this.dataService.post('callDistribution/regionWiseAvgDuration', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
          this.regionWiseDurationChart(res['data'])
          // this.leadResponseChart(res['data'][0])
        }
        else{
            this.dataService.showError(res['message']);
            if(res['code'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        this.dataService.showError(err['message']);
    })
}
public callVolumeRegion(info) {
  // console.log(info)
  Highcharts.chart('callVolumeRegion', {
    chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
    },
    exporting: { enabled: false },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y} %'
            }
        }
    },
    series: [{
        name: '',
        colorByPoint: true,
        data: info
    }]
});
}

getCallVolumeRegionData() {
  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    channel: this.channelName,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date,
    filterValue: this.callVolumeSelected

}
    this.dataService.post('callDistribution/callVolumeRegion', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
          this.callVolumeRegion(res['data'])
          // this.leadResponseChart(res['data'][0])
        }
        else{
            this.dataService.showError(res['message']);
            if(res['code'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        this.dataService.showError(err['message']);
    })
}
public callDurationPercentage(info) {
  Highcharts.chart('callDurationPercentage', {
    chart: {
      type: 'column'
    },
    exporting: { enabled: false },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    accessibility: {
      announceNewData: {
        enabled: true
      }
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      title: {
        text: ''
      }
  
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y}%'
        }
      }
    },
  
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}%</b> of total<br/>'
    },
  
    series: [
      {
        name: "",
        colorByPoint: true,
        data: info
      }
    ]
  });
}

getcallDurationPercentageData() {
  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    channel: this.channelName,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date
}
    this.dataService.post('callDistribution/callDurationPercentage', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
          this.callDurationPercentage(res['data'])
          // this.leadResponseChart(res['data'][0])
        }
        else{
            this.dataService.showError(res['message']);
            if(res['code'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        this.dataService.showError(err['message']);
    })
}

public distributionByDayData(info) {
  Highcharts.chart('distributionByDay', {
    chart: {
      type: 'column'
    },
    exporting: { enabled: false },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    accessibility: {
      announceNewData: {
        enabled: true
      }
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      title: {
        text: ''
      }
  
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y}'
        }
      }
    },
  
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> of total<br/>'
    },
  
    series: [
      {
        name: "",
        colorByPoint: true,
        data: info
      }
    ]
  });
}
getDistributionByDayData() {
  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    channel: this.channelName,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date
}
    this.dataService.post('callDistribution/distributionByDayGraph', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
          this.distributionByDayData(res['data'])
          // this.leadResponseChart(res['data'][0])
        }
        else{
            this.dataService.showError(res['message']);
            if(res['code'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        this.dataService.showError(err['message']);
    })
}
onChange (value) {
this.callVolumeSelected = value;
this.getCallVolumeRegionData();
}

  public clearFilter() {
    this.dataService.removeCookies("hyperLocalFilter", "");

  this.selectedZone = [];
  this.selectedRegion = [];
  this.selectedParent = [];
  this.selectedChannel = [];
  this.selectedOutlet = [];
  this.selectedOutletType = [];
    
    window.location.reload();
  }
 
  checkCallDistributionDate(): void {
    if (!this.filterForm.value.start_date) return;
    const envDate = environment.callDistributionDeployDate;
    const deployDate = new Date(envDate);
    const selectedDate = new Date(this.filterForm.value.start_date);
    this.columnList = selectedDate > deployDate ? column['default']['new'] : column['default']['old'];
    if (this.isSelectedAll) {
      this.column = this.columnList;
      this.onColumnAll(this.columnList)
    }else{
      this.column = (this.selectedColumn.length > 0) ? this.columnList.filter((dd:any) => this.selectedColumn.includes(dd.column_name)) : [];
      this.selectedColumn = (this.column.length > 0) ? this.column.map((d:any) => d.column_name) : [];
    }
  }

}
